module.exports = __webpack_public_path__ + "static/img/jc_zt_sec2_img1.996c0d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/advertisement/introduceThree/jc_zt_sec2_img1.jpg
// module id = qBZm
// module chunks = 171